import virtualizedMailGroupHeadersStore from "../store/store";
import type { TableView } from "owa-mail-list-store";

// Gets the indices of hidden rows from collapsed group headers. Note that it does not include the 1st row in the group header
// as that row will include the group header itself in the virtualized message list which is not hidden. The mail row however will be hidden.
export default function getIndicesOfHiddenRowsInCollapsedGroupHeaders(tableView: TableView): number[] {
    const hiddenRowIndices: number[] = [];
    const groupHeadersFromStore = virtualizedMailGroupHeadersStore().virtualizedGroupHeaders;
    
    for (const [_headerId, header] of groupHeadersFromStore.entries()) {
        if (header.isCollapsed) {
            const rowKeysInHeader = header.rowKeys;
            let smallestIndex = Number.MAX_SAFE_INTEGER;
            
            for (let i = 0; i < rowKeysInHeader.length; i++) {
                const rowKey = rowKeysInHeader[i];
                const rowIndex = tableView.rowKeys.indexOf(rowKey);
                if (rowIndex !== -1) {
                    hiddenRowIndices.push(rowIndex);
                    
                    if (rowIndex < smallestIndex) {
                        smallestIndex = rowIndex;
                    }
                }
            }
            // Remove the smallest index from hiddenRowIndices for each collapsed group header
            const indexToRemove = hiddenRowIndices.indexOf(smallestIndex);
            if (indexToRemove !== -1) {
                hiddenRowIndices.splice(indexToRemove, 1);
            }
        }
    }
    
    return hiddenRowIndices;
}
